import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumber]'
})
export class NumberDirective {
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): boolean {
    const pattern = /^[0-9]*$/;
    return pattern.test(event.key);
  }
}
